import { Pagination } from '@common/components/list';
import { EConversationActivityTypes, EConversationTypes, EMessageTypes } from '../definitions';

import type { MessageEmojiReaction, User, Attachment, EmojiReaction } from '@common/types/objects';
import type { ObjectValues } from '@common/types/util-types';

/**
 * @deprecated
 */
export type ReceivedMessageSource = {
  type: ObjectValues<typeof EMessageTypes>;
  id: string;
  object_id: string | null;
  text: string;
  created_at: string;
};

/**
 * @deprecated
 */
export type ReceivedMessageChild = {
  id: string;
  created_at: string;
  object_type: string;
  parent_id: number;
  parent_type: string;
  source_id: string;
  user_id: string;
  source: Attachment;
};

/**
 * @deprecated
 */
export type ReceivedMessage = {
  id: string;
  user_id: string;
  object_type: ObjectValues<typeof EMessageTypes>;
  source_id: string;
  parent_type: string;
  parent_id: string;
  replies_to: string | null;
  is_forwarded: boolean;
  network_id: string | null;
  organisation_id: string | null;
  seen: boolean;
  seen_count: number;
  created_at: string;
  deleted_at: string | null;
  source: ReceivedMessageSource;
  parent_message: ReceivedMessage | null;
  children: ReceivedMessageChild[];
  reactions: MessageEmojiReaction[];
};

interface APIResponseAttachment {
  id: string;
  source_id: string;
  user_id: string;
  object_type: Attachment['type'];
  source: Attachment;
  created_at: string;
}

type MessageTypes = typeof EMessageTypes[keyof typeof EMessageTypes];

export interface APIResponsePrivateMessage {
  id: string;
  object_type: MessageTypes;
  is_forwarded: boolean;
  is_edited: boolean;
  seen: boolean;
  network_id: string | null;
  organisation_id: string | null;
  parent_id: string | null;
  user_id: string | null;
  replies_to: string | null;
  source_id: string;
  seen_count: number;
  parent_type: 'conversation';
  parent_message: APIResponsePrivateMessage | null;
  children: APIResponseAttachment[];
  reactions: EmojiReaction[];
  source: {
    id: string;
    object_id: string;
    text: string;
    type: MessageTypes;
    activity_type?: typeof EConversationActivityTypes[keyof typeof EConversationActivityTypes];
    created_at: string;
    meta_data?: {
      actor_id?: string;
      user_id?: string;
      actor?: User;
      user?: User;
    };
  };
  created_at: string;
  deleted_at: string | null;
}

export type PrivateMessage = {
  id: string;
  object_id: string;
  type: MessageTypes;
  text: string;
  seen: boolean;
  is_default_seen?: boolean;
  is_edited?: boolean;
  user_id: string | null;
  user: User | null;
  parent_id?: string | null;
  parent_message?: PrivateMessage;
  reactions: MessageEmojiReaction[];
  attachments: Attachment[];
  activity_type?: typeof EConversationActivityTypes[keyof typeof EConversationActivityTypes];
  meta_data?: {
    actor_id?: string;
    user_id?: string;
    actor?: User;
    user?: User;
    new_name?: string;
  };
  created_at: string;
  deleted_at?: string;
};

/**
 * @deprecated
 */
export type Conversation = {
  id: string;
  name?: string;
  conversation_type: typeof EConversationTypes;
  participant_ids: Array<string>;
  is_muted: boolean;
  has_left: boolean;
  user_id: string;
  admin_ids: Array<string>;
};

export type APIResponseConversation = {
  id: string;
  organisation_id: string;
  name: string | null;
  description?: string;
  conversation_type: typeof EConversationTypes[keyof typeof EConversationTypes];
  group_img?: string;
  last_message: APIResponsePrivateMessage | null;
  has_left: boolean;
  is_muted: boolean;
  is_archived: boolean;
  is_pinned: boolean;
  is_favourite: boolean;
  is_favorite: boolean;
  last_activity_id: string;
  user_id: string;
  participant_ids: string[];
  admin_ids: string[];
  updated_at: string;
  created_at: string;
};

export type FullConversation = Omit<APIResponseConversation, 'last_message'> & {
  is_admin: boolean;
  is_active?: boolean;
  is_message_search?: boolean;
  last_message: PrivateMessage | null;
  participant: User | null;
  participants: User[];
  admins: User[];
  creator?: User;
};

export type APIResponseFetchConversations = {
  data: FullConversation[] | undefined;
  meta: {
    pagination: Pagination;
    related: {
      users: User[];
      conversations: APIResponseConversation[];
    };
  };
};

export enum ESearhFilterTypes {
  CHATS = 'chats',
  MESSAGES = 'messages',
}

export enum EConversationFilterTypes {
  ALL = 'all',
  UNREAD = 'unread',
  FAVORITES = 'favorites',
  GROUPS = 'groups',
  ARCHIVED = 'archived',
}

